namespace $.$$ {
	export class $mol_theme_auto extends $.$mol_theme_auto {

		theme() {
			return this.$.$mol_lights() ? '$mol_theme_light' : '$mol_theme_dark'
		}

	}
}
